import { CalculatedDimension } from "./calculated-dimension";

export class PercentDimension extends CalculatedDimension {
  constructor(scale) {
    super();
    this.scale = scale;
  }

  isEquals(other) {
    return this.scale == other.scale;
  }

  isNeedUpdate(parentDimension) {
    let v = this.scale * parentDimension;
    return v != this.currValue;
  }

  calcValue(parentDimension) {
    this.currValue = this.scale * parentDimension;
    return this.currValue;
  }

  copy() {
    return new PercentDimension(this.scale);
  }
}
